module.exports = __webpack_public_path__ + "img/banner.19f634c8.png";